import { PageContainer } from "../components/PageContainer";
import { LoginForm } from "../components/LoginForm/LoginForm";

export const Login = () => {
  return (
    <PageContainer>
      <LoginForm />
    </PageContainer>
  );
};
